<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="stylus">
html,body{
  overflow hidden
}
#app {
  height: 100vh;
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.flex{
  display: flex;
}
.align-center{
  align-items: center;
}
.relative, .filter_relative{
  position: relative;
}
.bg-white{
  background: #fff;
}
.ivu-text-center{
  text-align: center!important;
}
.ivu-text-left{
  text-align: left;
}
.ivu-text-right{
  text-align: right;
}
// .ivu-select-dropdown{
//   max-height 350px
// }
.add_page{
  background: #fff;
  padding: 16px;
  .title{
    font-size: 18px;
    margin: 0 0 10px;
    font-weight: bold;
    text-align: left;
  }
}
.ivu-tabs-nav-container {
  margin: 0;
}

.edit_page {
  background: #fff;
  padding: 16px;
  /deep/ .ivu-tabs-nav {
    background: #fff !important;
  }
  .title {
    font-size: 18px;
    margin: 0 0 10px;
    font-weight: bold;
    text-align: left;
  }
}
.user_page{
  .ivu-table-wrapper{
    overflow: inherit;
  }
  .user_page_form{
    .ivu-form-item {
      padding: 0 12px;
    }
  }
}
p.audit-title{
    text-align left
    font-size 15px
    font-weight 700
    margin 10px 0
  }
.ivu-card-body {
  height: 100%;
}
.ivu-form-item{
  margin-bottom: 10px;
}
.mt20{
  margin-top: 20px;
}
.mt10{
  margin-top: 10px;
}
.mb10{
  margin-bottom 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue